import { TConfig } from '@/typings';
import logo from './img/logo-ecosur.png';

export const config: TConfig = {
  title: 'Sistema de gestión de estancias',
  logo: logo,
};
